import React,{Component} from 'react';
import Countdown from './Countdown'
import {Link} from 'react-router-dom';
import feature from '../assets/images/features/feature-header.jpeg'

export default class Hero extends Component{
    constructor(props){
        super(props);
        this.state = {
            location: ''
        }
    }
    componentDidMount(){
        this.setState({
            location: window.location.pathname.split('/')[1]
        })        
    }

    render(){        
        const {title, subHeading, buttonText, imgSrc, isPricing, isTextDefault, isImage, isCta, isCenterImage, countdown} = this.props;
        const {location} = this.state;
        const bgImage = {
            "":'home',
            "im-influencer": 'influencer',
            "features" : "features",
            "pricing" : "pricing",
            "awards" : "circle",
        }[location]        
        return(
            <div id="hero" className={bgImage}>
                <div className="container">
                {isTextDefault ? 
                    <div className="text_middle">
                        {title}
                        <p>{subHeading}</p>
                        <div className="buttons">
                            <Link to="/signup">
                                <button className="btn btn-default bg-green"><span>{buttonText}</span></button>
                            </Link>
                        </div>
                    </div> :
                    <div className="text_center">
                        {title}
                        <p>{subHeading}</p>                    
                        {isCta && 
                            <div className="hero_cta">
                                <button className="btn btn-default bg-green">Lorem Ipsum</button>
                                <button className="btn btn-default">Lorem Ipsum</button>
                            </div>
                        }
                        {buttonText && <div className="buttons">
                            <Link to="/signup">
                                <button className="btn btn-default bg-green"><span>{buttonText}</span></button>
                            </Link>
                        </div>}
                    </div>
                }
                    {isPricing && 
                        <div className="services">
                            <div className="service">
                                <h4>Self-Service for Brands</h4>
                                <h2>0%</h2>
                                <p>
                                    Gunakan langsung platform SosiaGo secara mandiri (self-service) dan lakukan top up saldo didepan (in-front) untuk menjalankan campaign placement/sponsored Anda dengan mudah. 
                                    Harga yang dibayar sesuai harga yang tertera (transparan) dan hanya dibayar setiap pekerjan yang telah Anda setujui saja.
                                    <br/><br/>
                                    <b>Benefit yang Anda dapat :</b>
                                    <br/><br/>
                                    Akses ke semua fitur yang ada di dalam dashboard. No-Hidden Fee dan tidak ada service charge (0%).
                                </p>
                                <Link to="/signup"><button className="btn btn-default bg-green"><span>MULAI GRATIS</span></button></Link>
                            </div>
                            <div className="service">
                                <h4>VIP-Service for Brands</h4>
                                <h2>5% - 20%</h2>
                                <p>Anda ingin terima beres untuk campaign placement / sponsored yang dijalankan dan membutuhkan invoicing late payment? Tim SosiaGo siap membantu untuk menjalankan campaign yang Anda butuhkan. Ada biaya tambahan (service fee) yang besarnya tergantung periode pembayaran & jumlah budget.
                                    <br/><br/>
                                    <b>Benefit yang Anda dapat :</b>
                                    <br/><br/>
                                    Anda hanya perlu duduk manis dan terima hasil secara lengkap dan sesuai yang Anda harapkan.
                                </p>
                                <Link to="/contact"><button className="btn btn-default bg-blue"><span>REQUEST MEETING</span></button></Link>
                            </div>
                        </div>
                    }
                    { isImage && 
                        <div className="images">
                            <div className="img">
                                <img src={imgSrc} />
                                {/* {imgSrc} */}
                            </div>
                        </div>
                    }
                    {
                        isCenterImage && 
                        <div className="images-center">
                            <div className="img">
                                <img src={imgSrc} />                                
                            </div>
                        </div>
                    }
                    {
                        countdown && <Countdown />
                    }
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Hero.js